
export function is_bus_available(item) {

    if( !item) {
        return false
    }

    return item.bus_available === true || item.bus_available === "true"
}

